import * as MuiIcons from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardCommandKeySharpIcon from '@mui/icons-material/KeyboardCommandKeySharp';
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Box,
  Button,
  Card,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ColDef,
  ColumnMovedEvent,
  ColumnVisibleEvent,
  GridReadyEvent,
  IServerSideGetRowsParams,
  SideBarDef
} from "ag-grid-community";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import {useCallback, useContext, useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { useHasScope, useHasScopes as hasScopes   } from "../../../../config/globalConfig";
import CustomLoader from "../../../../util/component/CustomLoader";
import SectionHeader from "../../../../util/component/SectionHeader";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { ContextOperation } from "../../context/OperationContext";
import useSnackbar from "../../hooks/useSnackbar";
import useToggle from "../../hooks/useToggle";
import { vehicleActions } from "../../service/vehicle.actions";
import TableDynamicActions from "../TableDynamicActions";
import AttachmentsVehicle from "../attachmentsVehicles/AttachmentsVehiclesTable";
import { AutoCompleteOption } from "../common/AutoComplete";
import ChecklistModal from "./ChecklistModal";
import EditVehicle from "./EditVehicle";
import CviFormDialogWrapper from "./CviFormDialog";
import EquipmentsModal from "./EquipmentsModal";
import FiltersModal from "./FiltersModal";
import FirstFueling from "./FirstFuelingModal";
import { FirstFuelingType } from "./FirstFuelingType";
import MaintenaceModal from "./MaintenaceModal";
import "./Vehicle.css";
import VehicleModal from "./VehicleModal";
import DownloadModal from "./DownloadModal";
import AgGridOperationTable from "../common/AgGridOperationTable";
import DownloadModalMassiveLock from "./DownloadModalMassiveLock";
import {EXPIRED_DEFAULT_COL_DEF} from "../../config";

export interface IChooseVehicle {
  id: number;
  vin: string;
  plate: string;
}
const VehicleSearch = (props: any) => {
  const hasScope = useHasScope;
  const snackbar = useSnackbar();
  const { tenant } = useContext(ContextOperation);
  const { t, i18n } = useTranslation(["operation"]);
  const [loading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [length, setLength] = useState<number>(0);
  const [gridApi, setGridApi] = useState<any>(null);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [success, setSuccess] = useState<boolean>(false);
  const [filter, setFilter] = useState<boolean>(false);
  const [maintenaceData, setMaintenaceData] = useState<any>({});
  const { dispatchGlobalData, globalData } = useContext(GlobalContext);
  const theme = useTheme();
  const [openMaintenaceModal, setOpenMaintenaceModal] =
    useState<boolean>(false);
  const [openEquipmentsModal, setOpenEquipmentsModal] =
    useState<boolean>(false);
  const [openVehicleAttachment, setOpenVehicleAttachment] =
    useState<boolean>(false);
  const [openChecklistModal, setOpenChecklistModal] = useState<boolean>(false);
  const [chooseVehicle, setChooseVehicle] = useState<IChooseVehicle>();
  const [selectedVehicle, setSelectedVehicle] = useState<any>({});
  const [vehicleId, setVehicleId] = useState<any>({});
  const [showEdit, toggleEdit] = useToggle();
  const [tireType, setTireType] = useState<AutoCompleteOption[]>([]);
  const [selecedAnVehicle, setSelectedAnVehicle] = useState<any>({
    plate: "",
    vin: "",
    brand: "",
    model: "",
  });
  const [data, setData] = useState<any>({
    brand: { id: "", descr: "" },
    model: { id: "", descr: "" },
    carSegment: { id: "", descr: "" },
    carClass: { id: "", descr: "" },
    carAcriss: { id: "", code: "" },
    carSipp: { id: "", code: "" },
    plate: "",
    vin: "",
    imeiPrimary: "",
    imeiSecondary: "",
    currentTireType: { code: "", description: "" },
    expectedSaleDateFrom: null,
    expectedSaleDateTo: null,
    inFleet: { id: "true", descr: t("internOptionSelectName.yes") },
    vehicleStatus: { id: "", descr: "" },
    firstFuelingDone: { id: "", descr: "" },
    enginePowerGroupCodes: [],
    reasonCode: [],
    ownership: "",
    extColor: "",
    registrationDateFrom: "",
    registrationDateTo: "",
    realDeliveryDateFrom: "",
    realDeliveryDateTo: "",
    keyless: ''
  });
  const [openDownloadModal, setOpenDownloadModal] = useToggle();
  const [openDownloadModalMassiveLock, setOpenDownloadModalMassiveLock] = useToggle();
  const [maintenaceDataArray, setMaintenaceDataArray] = useState<any>([]);
  const [firstFueling, setFirstFueling] = useState<boolean>(false);
  const [resetPower, setResetPower] = useState<boolean>(false);
  const [fuelingData, setFuelingData] = useState<
    FirstFuelingType.Data | undefined
  >();
  const [openMaintenanceData, setOpenMaintenanceData] = useState<boolean>(false);
  const [openVehicleCommandData, setOpenVehicleCommandData] = useState<boolean>(false);//P.N.

  const maintenaceAction = vehicleActions();

  const onSubmit = () => {
    onSearch();
  };

  const cancel = () => {
    setData({
      brand: { id: "", descr: "" },
      model: { id: "", descr: "" },
      carSegment: { id: "", descr: "" },
      carClass: { id: "", descr: "" },
      carAcriss: { id: "", code: "" },
      carSipp: { id: "", code: "" },
      plate: "",
      vin: "",
      imeiPrimary: "",
      imeiSecondary: "",
      currentTireType: { code: "", description: "" },
      expectedSaleDateFrom: null,
      expectedSaleDateTo: null,
      inFleet: { id: "true", descr: `${t("internOptionSelectName.yes")}` },
      vehicleStatus: { id: "", descr: "" },
      firstFuelingDone: { id: "", descr: "" },
      enginePowerGroupCodes: [],
      ownership: "",
      extColor: "",
      registrationDateFrom: "",
      registrationDateTo: "",
      realDeliveryDateFrom: "",
      realDeliveryDateTo: "",
      keyless: ''
    });
    setFilter(!filter);
    setResetPower(true);
  };
  const openEditModal = (id: number) => {
    setVehicleId(id);
    toggleEdit();
  };

  const showOpenVehicleCommand = (data: any) => {//P.N.
    setVehicleId(data.id)
    setSelectedVehicle(data);
    setOpenVehicleCommandData(!openVehicleCommandData);
  };

  function onSearch() {
    setResetPower(false);

    let engineId: any = [];
    data.enginePowerGroupCodes.map((el: any) => engineId.push(el.value));
    console.log(engineId, "engineId");

    let brandId = data.brand.id ? data.brand.id : null;
    let modelId = data.model.id ? data.model.id : null;
    let carSegmentId = data.carSegment.id ? data.carSegment.id : null;
    let carClassId = data.carClass.id ? data.carClass.id : null;
    let acrissId = data.carAcriss.id ? data.carAcriss.id : null;
    let customAcrissId = data.carSipp.id ? data.carSipp.id : null;
    let vin = data.vin ? data.vin.trim() : null;
    let plate = data.plate ? data.plate.trim() : null;
    let imeiPrimary = data.imeiPrimary ? data.imeiPrimary.trim() : null;
    let imeiSecondary = data.imeiSecondary ? data.imeiSecondary.trim() : null;
    let currentTireTypeCode = data.currentTireType.code ? data.currentTireType.code : null;
    let expectedSaleDateFrom = dayjs(data?.expectedSaleDateFrom).isValid() ? dayjs(data?.expectedSaleDateFrom).format("YYYY-MM-DD") : null;
    let expectedSaleDateTo = dayjs(data?.expectedSaleDateTo).isValid() ? dayjs(data?.expectedSaleDateTo).format("YYYY-MM-DD") : null;
    let inFleet = !!data.inFleet.id ? data.inFleet.id : null;
    let vehicleStatusId = data.vehicleStatus.id ? data.vehicleStatus.id : null;
    let firstFuelingDoneId = data.firstFuelingDone.id ? data.firstFuelingDone.id : null;
    let enginePowerGroupCodes = engineId.length > 0 ? engineId.toString() : null;
    
    let ownership = data.ownership ? data.ownership : null;
    let extColor = data.extColor ? encodeURI(data.extColor.trim()) : null;
    let registrationDateFrom = dayjs(data?.registrationDateFrom).isValid() ? dayjs(data?.registrationDateFrom).format("YYYY-MM-DD") : null;
    let registrationDateTo = dayjs(data?.registrationDateTo).isValid() ? dayjs(data?.registrationDateTo).format("YYYY-MM-DD") : null;
    let realDeliveryDateFrom = dayjs(data?.realDeliveryDateFrom).isValid() ? dayjs(data?.realDeliveryDateFrom).format("YYYY-MM-DD") : null;
    let realDeliveryDateTo = dayjs(data?.realDeliveryDateTo).isValid() ? dayjs(data?.realDeliveryDateTo).format("YYYY-MM-DD") : null;
    let keyless = data.keyless === '' ? undefined : Boolean(data.keyless);

    setIsLoading(true);
    return {
      getRows: async (serverSide: IServerSideGetRowsParams) => {
        const startRow = serverSide.request.startRow
          ? serverSide.request.startRow
          : 0;
        const endRow = serverSide.request.endRow;

        const sortCode = serverSide.request.sortModel[0]?.colId;
        const sortDirection  = serverSide.request.sortModel[0]?.sort;
    
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;
        vehicleActions()
          .getAllVehicle(
            tenant,
            pageSize,
            pageNumber,
            sortCode,
            sortDirection,
            brandId,
            modelId,
            carSegmentId,
            carClassId,
            acrissId,
            customAcrissId,
            vin,
            plate,
            imeiPrimary,
            imeiSecondary,
            currentTireTypeCode,
            expectedSaleDateFrom,
            expectedSaleDateTo,
            inFleet,
            vehicleStatusId,
            firstFuelingDoneId,
            enginePowerGroupCodes,
            data.reasonCode,
            ownership,
            extColor,
            registrationDateFrom,
            registrationDateTo,
            realDeliveryDateFrom,
            realDeliveryDateTo,
            keyless
          )
          .then((response: any) => {
            serverSide.successCallback(
              manageData(response),
              response.data.totalElements
            );
            setLength(response.data.totalElements);
            setIsLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.msg,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
          });
      },
    };
  }

  function downloadExcel() {
    setIsLoading(true);
    let engineId: any = [];
    if (data.enginePowerGroupCodes !== null) {
      data.enginePowerGroupCodes.map((el: any) => engineId.push(el.value));
    }
    let brandId = data.brand.id ? data.brand.id : null;
    let modelId = data.model.id ? data.model.id : null;
    let carSegmentId = data.carSegment.id ? data.carSegment.id : null;
    let carClassId = data.carClass.id ? data.carClass.id : null;
    let acrissId = data.carAcriss.id ? data.carAcriss.id : null;
    let customAcrissId = data.carSipp.id ? data.carSipp.id : null;
    let vin = data.vin ? data.vin : null;
    let plate = data.plate ? data.plate : null;
    let imeiPrimary = data.imeiPrimary ? data.imeiPrimary : null;
    let imeiSecondary = data.imeiSecondary ? data.imeiSecondary : null;
    let currentTireTypeCode = data.currentTireType.code ? data.currentTireType.code : null;
    let expectedSaleDateFrom = dayjs(data?.expectedSaleDateFrom).isValid() ? dayjs(data?.expectedSaleDateFrom).format("YYYY-MM-DD") : null;
    let expectedSaleDateTo = dayjs(data?.expectedSaleDateTo).isValid() ? dayjs(data?.expectedSaleDateTo).format("YYYY-MM-DD") : null;
    let inFleet = data.inFleet.id;
    let vehicleStatusId = data.vehicleStatus.id ? data.vehicleStatus.id : null;
    let firstFuelingDoneId = data.firstFuelingDone.id ? data.firstFuelingDone.id : null;
    let enginePowerGroupCodes = engineId.length > 0 ? engineId.toString() : null;
    
    let ownership = data.ownership ? data.ownership : null;
    let extColor = data.extColor ? encodeURI(data.extColor) : null;
    let registrationDateFrom = dayjs(data?.registrationDateFrom).isValid() ? dayjs(data?.registrationDateFrom).format("YYYY-MM-DD") : null;
    let registrationDateTo = dayjs(data?.registrationDateTo).isValid() ? dayjs(data?.registrationDateTo).format("YYYY-MM-DD") : null;
    let realDeliveryDateFrom = dayjs(data?.realDeliveryDateFrom).isValid() ? dayjs(data?.realDeliveryDateFrom).format("YYYY-MM-DD") : null;
    let realDeliveryDateTo = dayjs(data?.realDeliveryDateTo).isValid() ? dayjs(data?.realDeliveryDateTo).format("YYYY-MM-DD") : null;
    let keyless = data.keyless === '' ? undefined : Boolean(data.keyless);

    vehicleActions()
      .exportDataVehicle(
        i18n.language,
        tenant,
        brandId,
        modelId,
        carSegmentId,
        carClassId,
        acrissId,
        customAcrissId,
        vin,
        plate,
        inFleet,
        vehicleStatusId,
        currentTireTypeCode,
        expectedSaleDateFrom,
        expectedSaleDateTo,
        imeiPrimary,
        imeiSecondary,
        firstFuelingDoneId,
        enginePowerGroupCodes,
        data.reasonCode,
        ownership,
        extColor,
        registrationDateFrom,
        registrationDateTo,
        realDeliveryDateFrom,
        realDeliveryDateTo,
        keyless
      )
      .then((response: any) => {
        setIsLoading(false);
        if (response.status === 200) {
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(blob, filename);
        } else setOpenDownloadModal();
      });
  }

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(onSearch());
    }
  }, [gridApi, filter, refreshData]);

  useEffect(() => {
    vehicleActions()
      .getAllTireType()
      .then((responceTireType: any) => {
        setTireType(
          responceTireType.data.map((res: any) => ({
            value: res.code,
            label: res.description,
          }))
        );
      });
  }, []);

  function manageData(response: any) {
    if (response !== undefined) {
      let rows: any = [];
      response.data.content.forEach((element: any) => {
        let row = {
          id: element?.id,
          brand: element?.model?.brand?.descr,
          model: element?.model?.descr,
          plate: element?.plate,
          carClass: element?.carClass?.descr,
          carSegment: element?.carSegment?.descr,
          acriss: element?.acriss?.code,
          customAcriss: element?.customAcriss?.code,
          ownerCategoryDesc: element?.ownerDescr,
          vin: element?.vin,
          vehicleStatus: element?.vehicleStatus,
          registrationDate:
            element?.registrationDate !== undefined
              ? element?.registrationDate
              : undefined,
          realDeliveryDate: !!element?.realDeliveryDate
            ? element?.realDeliveryDate
            : "",
          colorExt: element?.colorExt,
          firstFuelingDone: element?.firstFuelingDone,
          reasonCodes: !!element?.reasonCodes ? element?.reasonCodes : "",
          reasonDescriptions: !!element?.reasonDescriptions ? element?.reasonDescriptions : "",
          keyless: element?.keyless === null ? '' : Number(element?.keyless)
        };
        rows.push(row);
      });
      return rows;
    }
  }

  const defaultColDef = useMemo<ColDef>(() => EXPIRED_DEFAULT_COL_DEF, []);

  const columns: ColDef[] = useMemo<ColDef[]>(() => [
      {
        field: "brand",
        headerName: t("vehicle.brand"),
        sortable: true,
        minWidth: 100,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.brand}>
              <span>{params.data.brand}</span>
            </Tooltip>
        ),
      },
      {
        field: "model",
        headerName: t("vehicle.model"),
        sortable: true,
        minWidth: 100,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.model}>
              <span>{params.data.model}</span>
            </Tooltip>
        ),
      },
      {
        field: "plate",
        headerName: t("carMaintenance.filterAndSearch.plate"),
        sortable: true,
        minWidth: 100,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.plate}>
              <span>{params.data.plate}</span>
            </Tooltip>
        ),
      },
      {
        field: "acriss",
        headerName: t("vehicle.acriss"),
        sortable: true,
        minWidth: 100,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.acriss}>
              <span>{params.data.acriss}</span>
            </Tooltip>
        ),
      },
      {
        field: "customAcriss",
        headerName: t("vehicle.sipp"),
        sortable: true,
        minWidth: 100,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.customAcriss}>
              <span>{params.data.customAcriss}</span>
            </Tooltip>
        ),
      },
      {
        field: "vin",
        headerName: t("carMaintenance.filterAndSearch.vin"),
        sortable: true,
        minWidth: 200,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.vin}>
              <span>{params.data.vin}</span>
            </Tooltip>
        ),
      },
      {
        field: "colorExt",
        headerName: t("vehicle.colorExt"),
        sortable: true,
        minWidth: 200,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data.colorExt}>
              <span>{params.data.colorExt}</span>
            </Tooltip>
        ),
      },
      {
        field: "registrationDate",
        headerName: t("vehicle.registrationDate"),
        sortable: true,
        minWidth: 150,
        cellRenderer: (params: any) => (
            <span>
          {!!params.data.registrationDate
              ? dayjs(`${params.data.registrationDate}`).format("DD/MM/YYYY")
              : undefined}
        </span>
        ),
      },
      {
        field: "realDeliveryDate",
        headerName: t("vehicle.realDeliveryDate"),
        sortable: true,
        minWidth: 150,
        cellRenderer: (params: any) => (
            <span>
          {!!params.data.realDeliveryDate
              ? dayjs(`${params.data.realDeliveryDate}`).format("DD/MM/YYYY")
              : undefined}
        </span>
        ),
      },
      {
        field: "id",
        headerName: "Id",
        sortable: false,
        minWidth: 100,
        hide: true,
      },
      {
        field: "vehicleStatus",
        headerName: t("vehicle.status"),
        sortable: false,
        minWidth: 150,
        cellRenderer: (params: any) => (
            <span>
          {params.data.vehicleStatus === "AVAILABLE"
              ? t("internOptionSelectName.available")
              : t("internOptionSelectName.notAvailable")}
        </span>
        ),
      },
      {
        field: "reasonCode",
        headerName: t("vehicle.reasonCode"),
        minWidth: 150,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data?.reasonCodes}>
              <span>{params.data?.reasonCodes}</span>
            </Tooltip>
        ),
      },
      {
        field: "reasonCodeDescription",
        headerName: t("vehicle.reasonCodeDescription"),
        minWidth: 250,
        cellRenderer: (params: any) => (
            <Tooltip title={params.data?.reasonDescriptions}>
              <span>{params.data?.reasonDescriptions}</span>
            </Tooltip>
        ),
      },
      {
        field: "keyless",
        headerName: t("vehicle.keyless"),
        minWidth: 250,
        hide: true,
        cellRenderer: (params: any) => {
          return (<span>{t(params.data?.keyless ? 'vehicle.yes' : 'vehicle.no')}</span>)
        },
      },
      {
        field: "_action",
        headerName: "",
        sortable: false,
        maxWidth: 100,
        minWidth: 100,
        pinned: "right",
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        cellRendererSelector: (params: any) => {
          const onClick = (e: any) => {
            setIsLoading(true);
            e.stopPropagation();
            vehicleActions()
                .getVehicleById(tenant, params.data.id)
                .then((res: any) => {
                  setIsLoading(false);
                  setModalData(res.data);
                  setOpenModal(true);
                });
          };
          return {
            component: () => (
                <TableDynamicActions moreColor={theme.palette.accent.main}>
                  <Tooltip
                      title={t("deliveryNote.table.tooltip.details")}
                      placement={"left"}
                      arrow={true}
                  >
                    <Button variant="text" size="icon" onClick={onClick}>
                      <MuiIcons.Description />
                    </Button>
                  </Tooltip>

                  {hasScope("SCOPE_UPDATE_MDVEHICLE_VEHICLE") && (
                      <Tooltip
                          title={t("tooltipTitle.edit")}
                          placement={"left"}
                          arrow={true}
                      >
                        <IconButton
                            className="edit-icon"
                            size="small"
                            aria-label="edit"
                            // onClick={onClick}
                        >
                          <EditIcon
                              fontSize="small"
                              onClick={() => openEditModal(params.data.id)}
                          />
                        </IconButton>
                      </Tooltip>
                  )}

                  <Tooltip
                      title={t("tooltipTitle.maintenance")}
                      placement={"left"}
                      arrow={true}
                  >
                    <IconButton onClick={() => getMaintenaceDataById(params)}>
                      <BuildCircleIcon
                          style={{ color: theme.palette.accent.main }}
                      />
                    </IconButton>
                  </Tooltip>

                  <Tooltip
                      title={t("tooltipTitle.equipment")}
                      placement={"left"}
                      arrow={true}
                  >
                    <IconButton
                        onClick={() => {
                          setSelectedVehicle(params.data);
                          setOpenEquipmentsModal(true);
                        }}
                    >
                      <SettingsIcon style={{ color: theme.palette.accent.main }} />
                    </IconButton>
                  </Tooltip>

                  {hasScope("SCOPE_UPDATE_MDVEHICLE_VEHICLE") && (
                      <Tooltip
                          title={t("tooltipTitle.attachment")}
                          placement={"left"}
                          arrow={true}
                      >
                        <IconButton
                            color="accent"
                            onClick={() => {
                              setOpenVehicleAttachment(true);
                              setVehicleId(params.data.id);
                              setSelectedAnVehicle({
                                ...selecedAnVehicle,
                                vin: params.data.vin,
                                plate: params.data.plate,
                                brand: params.data.brand,
                                model: params.data.model,
                              });
                            }}
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </Tooltip>
                  )}

                  <Tooltip
                      title={t("vehicle.checkList.tooltip")}
                      placement={"left"}
                      arrow={true}
                  >
                    <IconButton
                        color="accent"
                        onClick={() => {
                          setChooseVehicle({
                            ...chooseVehicle,
                            id: params.data.id,
                            plate: params.data.plate,
                            vin: params.data.vin,
                          });
                          setOpenChecklistModal(true);
                        }}
                    >
                      <FactCheckIcon />
                    </IconButton>
                  </Tooltip>

                  {hasScope("SCOPE_VIEW_MDVEHICLE_FIRSTFUELING") && (
                      <Tooltip
                          title={t("vehicle.firstFuelling.tooltip")}
                          placement={"left"}
                          arrow={true}
                      >
                        <Button
                            variant="text"
                            size="icon"
                            disabled={!!params?.data?.firstFuelingDone ? false : true}
                            onClick={() => {
                              setIsLoading(true);
                              setVehicleId(params.data.id);
                              maintenaceAction
                                  .firstFuelingData(params?.data?.id, tenant)
                                  .then((response) => {
                                    setIsLoading(false);
                                    setFuelingData({
                                      ...response,
                                      id: params?.data?.id,
                                    });
                                    setFirstFueling(true);
                                  })
                                  .catch((response: any) => {
                                    setIsLoading(false);
                                    snackbar.show("error", t("networkErrorMessage"));
                                  });
                            }}
                        >
                          <LocalGasStationIcon />
                        </Button>
                      </Tooltip>
                  )}

                {(() => {
                    const readonlyCommand = getReadonlyCommand('command',params.data);
                    return (
                        <Tooltip
                            title="Command"
                            placement="left"
                            arrow >
                            <IconButton
                                className="edit-icon"
                                size="small"
                                aria-label="edit"
                                disabled={readonlyCommand}
                                onClick={!readonlyCommand ? () => showOpenVehicleCommand(params.data) : undefined}
                            >
                                <KeyboardCommandKeySharpIcon
                                    fontSize="small"
                                    sx={{
                                        color: readonlyCommand ? 'rgba(0, 0, 0, 0.26)' : 'inherit'
                                    }}
                                />
                            </IconButton>
                        </Tooltip>
                    );
                })()}

                </TableDynamicActions>
            ),
          };
        },
      },
    ], [tenant]);

  const sideBar = useMemo<SideBarDef>(() => ({
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressColumnExpandAll: true,
        },
      },
    ],
    defaultToolPanel: '',
    position: 'right'
  }), []);

  const columnStateStorageKey = useMemo(() => {
    return `__OPERATION_PENDING.vehicleSearchTableColumsConfig:${globalData.user.username}`;
  }, [globalData.user.username]);

  const onGridReady = useCallback((event: GridReadyEvent) => {
    const colState = JSON.parse(localStorage.getItem(columnStateStorageKey) || '[]');

    event.columnApi.applyColumnState({
      state: colState,
      applyOrder: true
    });

    event.api.sizeColumnsToFit();
    setGridApi(event.api);
  }, [columnStateStorageKey]);

  const onColumnVisible = useCallback((event: ColumnVisibleEvent) => {
    localStorage.setItem(columnStateStorageKey, JSON.stringify(event.columnApi.getColumnState()));
  }, [columnStateStorageKey]);

  const onColumnMoved = useCallback((event: ColumnMovedEvent) => {
    localStorage.setItem(columnStateStorageKey, JSON.stringify(event.columnApi.getColumnState()));
  }, [columnStateStorageKey]);

  const showMaintenace = () => {
    if (openMaintenanceData) setOpenMaintenaceModal(true);
  };

  const getQueryParam = (param: string): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    return !(urlParams.get(param)?.toLowerCase() === 'true'); // Gestisce anche valori con maiuscole/minuscole
  };

  const getReadonlyCommand = (name: string, param:any): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    const qNameVal = (urlParams.get(name)?.toLowerCase() === 'true'); //p.n. da sostituire con il profilo
    if((qNameVal || hasScope("SCOPE_VEHICLE_SEND_COMMAND")) && param?.reasonCodes && param?.keyless===1){
      return ['ORE'].includes(param?.reasonCodes);
    }
    return true;
  };

  const getMaintenaceDataById = (maintenace: any) => {
    setIsLoading(true);
    setOpenMaintenanceData(true);
    maintenaceAction
      .getMainTenanceById(tenant, maintenace.data.id)
      .then((response: any) => {
        setMaintenaceDataArray(response.data.maintenances);
        setIsLoading(false);
      });
    setMaintenaceData(maintenace.data);
  };

  useEffect(showMaintenace, [maintenaceDataArray]);

  const downloadTemplate = (): void => {
    setIsLoading(true);
    maintenaceAction
      .downloadTemplate(tenant)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response?.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      })
      .catch(() => {
        setIsLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t("vehicle.templateButton.fail"),
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };

  const onPriceListChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      let priceList = event.target.files[0];
      const formData = new FormData();
      formData.append("file", priceList);

      if (priceList) {
        setIsLoading(true);
        maintenaceAction
          .uploadPriceList(tenant, formData)
          .then((response: any) => {
            setIsLoading(false);
            if (response.status === 200) {
              const filename =
                response.headers["content-disposition"].split("filename=")[1];
              var blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              FileSaver.saveAs(blob, filename);
            } else setOpenDownloadModalMassiveLock();
          })
          .catch((error: any) => {
            setIsLoading(false);
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t("vehicle.templateButton.uploadFail"),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
          });
      }
      event.target.value = null;
    }
  };

  return (
    <>
      {!openVehicleAttachment ? (
        <div>
          <SectionHeader title={t("vehicle.titleFirst")} />
          <FiltersModal
            filtersToParent={setData}
            data={data}
            setData={setData}
            cancel={cancel}
            setFilter={setFilter}
            filter={filter}
            tenant={tenant}
            resetPower={resetPower}
          />

          <Box className="carBrandOuterTableBox">
            <Box>
              <Card>
                <Stack
                  pr={1}
                  spacing={1}
                  direction={"row"}
                  minHeight={46}
                  display="flex"
                  justifyContent={"flex-end"}
                  alignItems="center"
                >
                  {hasScope("SCOPE_UPDATE_MDVEHICLE_VEHICLE") && (
                    <Box>
                      <Button
                        variant="outlined"
                        onClick={downloadTemplate}
                        startIcon={<FileDownloadIcon />}
                      >
                        <Typography color={"accent"} fontWeight={700}>
                          {t("vehicle.templateButton.download")}
                        </Typography>
                      </Button>
                    </Box>
                  )}
                  {hasScope("SCOPE_UPSERT_UNAVAILABILITIES") && (
                    <Box>
                      <label htmlFor="upload-priceList">
                        <input
                          style={{ display: "none" }}
                          id="upload-priceList"
                          onChange={onPriceListChange}
                          name="upload-priceList"
                          type="file"
                        />
                        <Button
                          component="span"
                          color="accent"
                          startIcon={<FileUploadIcon />}
                        >
                          <Typography
                            color={!props.hasSupplierId ? "accent" : "white"}
                            fontWeight={700}
                          >
                            {t("vehicle.templateButton.upload")}
                          </Typography>
                        </Button>
                      </label>
                    </Box>
                  )}
                  <Box
                    minHeight={46}
                    pr={1}
                    display="flex"
                    justifyContent={"flex-end"}
                    alignItems="center"
                  >
                    <Tooltip title={t("tooltipTitle.download")}>
                      <IconButton
                        color="accent"
                        disabled={length === 0}
                        onClick={downloadExcel}
                      >
                        <FileDownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Stack>
              </Card>
            </Box>

            <AgGridOperationTable
                columnDefs={columns}
                defaultColDef={defaultColDef}
                onColumnVisible={onColumnVisible}
                onColumnMoved={onColumnMoved}
                onGridReady={onGridReady}
                cacheBlockSize={pageSize}
                serverSideInfiniteScroll={true}
                rowModelType={"serverSide"}
				totalElements={length}
                sideBar={sideBar}
              />

          </Box>
        </div>
      ) : (
        <AttachmentsVehicle
          tenant={tenant}
          selectedAnVehicle={selecedAnVehicle}
          id={vehicleId}
          setOpenVehicleAttachment={setOpenVehicleAttachment}
          //closeModal={setOpenEquipmentsModal}
        />
      )}
      {loading && <CustomLoader loading={loading} />}
      {openModal && (
        <VehicleModal
          tenant={tenant}
          closeModal={setOpenModal}
          data={modalData}
          childToParent={setSuccess}
          tireType={tireType}
        />
      )}
      {openMaintenaceModal && (
        <MaintenaceModal
          tenant={tenant}
          closeModal={setOpenMaintenaceModal}
          maintenaceDataArray={maintenaceDataArray}
          maintenaceData={maintenaceData}
        />
      )}
      {openEquipmentsModal && (
        <EquipmentsModal
          tenant={tenant}
          vehicle={selectedVehicle}
          closeModal={setOpenEquipmentsModal}
        />
      )}
      {openChecklistModal && (
        <ChecklistModal
          tenant={tenant}
          chooseVehicle={chooseVehicle}
          openChecklistModal={openChecklistModal}
          setOpenChecklistModal={setOpenChecklistModal}
        />
      )}
      {firstFueling && (
        <FirstFueling
          firstFueling={firstFueling}
          setFirstFueling={setFirstFueling}
          fuelingData={fuelingData}
          vehicleId={vehicleId}
        />
      )}
      {openVehicleCommandData && (
        <CviFormDialogWrapper
          open={openVehicleCommandData}
          paramValues={{...selectedVehicle,...{'carVin':selectedVehicle.vin}}}
          onClose={() => {
            console.log('close');
            setOpenVehicleCommandData(!openVehicleCommandData)
          }}
          onSubmit={(env: any) => {
            console.log('This is a function inside defaultInitialValues' + JSON.stringify(env));
            setOpenVehicleCommandData(!openVehicleCommandData)
          }}
        />
      )}

      <EditVehicle
        open={showEdit}
        tireType={tireType}
        onClose={toggleEdit}
        vehicleId={vehicleId}
        updateDatasourceDamage={setFilter}
      />

      {openDownloadModal && (
        <DownloadModal setOpenDownloadModal={setOpenDownloadModal} />
      )}
      {openDownloadModalMassiveLock && (
        <DownloadModalMassiveLock setOpenDownloadModal={setOpenDownloadModalMassiveLock} />
      )}
    </>
  );
};

export default VehicleSearch;
